import React from 'react'
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import i18next from 'i18next'

import LanguageSelectorFormControl from './LanguageSelectorFormControl'
import GridContainer from './GridContainer'
import Button from './Button'
import adminStyles from './styles/admin.scss'

export default class Account extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      language: props.currentAccount.currentLanguage,
      signature: props.currentAccount.signature
    }
  }

  render() {
    return (
      <GridContainer>
        <div className={adminStyles.app}>
          <header>
            <h1>{i18next.t('own_settings')}</h1>
          </header>

          <Row>
            <Col sm={2}>
              <LanguageSelectorFormControl
                label={i18next.t('ui_language')}
                onChange={this.onChange.bind(this)}
                defaultValue={this.state.language}
                showOnlyAdminLanguages={true}
              />
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <FormGroup controlId="signature">
                <ControlLabel>{i18next.t('signature')}</ControlLabel>

                <FormControl
                  name="signature"
                  componentClass="textarea"
                  onChange={this.onChange.bind(this)}
                  value={this.state.signature}
                  rows="4"
                />
              </FormGroup>
            </Col>
          </Row>

          <div style={{ marginBottom: 20 }}>
            <Button text={i18next.t('save')} onClick={this.onSave.bind(this)} />
          </div>
        </div>
      </GridContainer>
    )
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSave() {
    this.props.onUpdateProfile(this.state.language, this.state.signature)
  }
}



// WEBPACK FOOTER //
// ./src/components/Account.js